import React, { useEffect } from "react";

import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import { ChatBox } from "@features/chat/mobile";
import { useRootAppStore } from "@hooks";
import { useFixBody } from "@state/hooks/shared";
import { isCapacitorPlatform } from "@utils/specific/capacitor/helpers";
import useSafeAreaListener from "@utils/specific/capacitor/useSafeAreaListener";
import { observer } from "mobx-react";

export default observer(function ChatContainer() {
	const { chatViewStore } = useRootAppStore();

	useEffect(() => {
		return () => chatViewStore.onDispose();
	}, []);

	useFixBody(true, chatViewStore.chatBoxVisible);

	const { top, bottom } = useSafeAreaListener();

	if (!chatViewStore.chatBoxVisible) {
		return null;
	}

	const chatPadding = isCapacitorPlatform()
		? {
				top: top,
				bottom: bottom,
			}
		: {};

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Mobile/ChatContainer.tsx"}
		>
			<div className="chat" style={chatPadding}>
				<ChatBox />
			</div>
		</ErrorBoundaryWithPropagation>
	);
});
